import React from 'react';
import NotificactionScreen from '../../components/Common/NotificactionScreen/NotificactionScreen';
import ContentApp from '../../components/ContentApp';
import { NoInternetIcon } from '../../components/icons/NoInternetIcon';
import { useTranslation } from 'react-i18next';


const OfflineScreen = () => {
    const { t } = useTranslation();
  return (
    <ContentApp classes={'py-0'}>
      <NotificactionScreen>
        <div className='d-flex justify-content-center w-100'>
          <NoInternetIcon color='var(--color-font-primary)' size='100px' />
        </div>
        <div className=' mt-5 pt-5'>
          <h3
            className='font-large bold text-left pl-3'
            style={{ color: 'var(--color-font-primary)' }}
          >
           {t('offline')}
          </h3>
          <p className='text-left pl-3 text-secondary'>
           {t('noInternetConnection')} <br />
           {t('mobileDataIsTurnedOn')}
          </p>
        </div>
      </NotificactionScreen>
    </ContentApp>
  );
};

export default OfflineScreen;
